module.exports = __webpack_public_path__ + "static/media/LandingPageVideo.56b52b26.jpg";